import Vue from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//import axios from "axios";

Vue.config.productionTip = false;

//Vue.prototype.$http = axios;
//Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_BASE_URL;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
